import { toast } from "sonner";
import { Switch } from "../ui/switch";
import { updateSetting } from "../../lib/api";
import { SECTION_DEFINITIONS } from "../../lib/tabs";
import { TOAST_NO_PERMISSION, TOAST_UPDATED, TOAST_SAVE_ERROR } from "../../lib/constants";

export default function AdminSectionsEditor({ readOnly = false, sections, setSections }) {
  return (
    <div data-id="admin-sections" className="animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="space-y-6 max-w-4xl">
        <div className="bg-white border border-fendi p-8 shadow-sm">
          <p className="eyebrow mb-2 text-champagne">Visibilidade das Seções</p>
          <p className="text-warmgray text-xs mb-8">Ative ou desative cada seção da página principal.</p>
          <div className="space-y-4">
            {SECTION_DEFINITIONS.map((s) => (
              <div key={s.key} className="border border-fendi/20 hover:border-fendi/40 transition-colors">
                <div className="flex items-center justify-between p-4">
                  <div>
                    <p className="text-sm font-medium text-softblack">{s.label}</p>
                    <p className="text-[11px] text-warmgray">{s.desc}</p>
                  </div>
                  <Switch
                    disabled={readOnly}
                    checked={sections?.[s.key] !== false}
                    onCheckedChange={async (checked) => {
                      if (readOnly) { toast.warning(TOAST_NO_PERMISSION); return; }
                      try {
                        await updateSetting(`section_${s.key}_visible`, checked.toString());
                        setSections((prev) => ({ ...prev, [s.key]: checked }));
                        toast.success(`${s.label} ${checked ? "ativada" : "desativada"}`);
                      } catch {
                        toast.error(TOAST_SAVE_ERROR);
                      }
                    }}
                  />
                </div>
                {s.elements?.length > 0 && (
                  <div className="border-t border-fendi/10 px-4 py-3 space-y-2 ml-6">
                    {s.elements.map((el) => (
                      <div key={el.key} className="flex items-center justify-between py-1">
                        <p className="text-xs text-warmgray">{el.label}</p>
                        <Switch
                          disabled={readOnly}
                          checked={sections?.[el.key] !== false}
                          onCheckedChange={async (checked) => {
                            if (readOnly) { toast.warning(TOAST_NO_PERMISSION); return; }
                            try {
                              await updateSetting(`element_${el.key}_visible`, checked.toString());
                              setSections((prev) => ({ ...prev, [el.key]: checked }));
                              toast.success(`${el.label} ${checked ? "ativada" : "desativada"}`);
                            } catch {
                              toast.error(TOAST_SAVE_ERROR);
                            }
                          }}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
